var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowFillRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.329501 0.329508C0.768836 -0.109842 1.48116 -0.109842 1.92049 0.329508L8.29544 6.70446C8.73479 7.1438 8.73479 7.85612 8.29544 8.29545L1.92049 14.6705C1.48116 15.1098 0.768836 15.1098 0.329501 14.6705C-0.109834 14.2311 -0.109834 13.5188 0.329501 13.0795L5.909 7.49996L0.329501 1.92041C-0.109834 1.48106 -0.109834 0.768858 0.329501 0.329508Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFillRightIcon);
export default __webpack_public_path__ + "static/media/arrow-fill-right-icon.02c81a8da07e97f33e85eb65a53543f2.svg";
export { ForwardRef as ReactComponent };